module.exports = __webpack_public_path__ + "img/message-text-square-01.876ef003.svg";